import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CommonService } from './services/common.service';
import { FormService } from './services/form/form.service';
import { EmbeddedParentViewportService } from './services/embedded-parent-viewport.service';
import { IframeHeightReporterService } from './services/iframe-height-reporter.service';
import { SignalRService } from './signalr.service';
import { ApiHttpService } from './services/api-http/api-http.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, MatProgressSpinner]
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    public commonService: CommonService,
    private formService: FormService,
    private signalRService: SignalRService,
    private api: ApiHttpService,
    private iframeHeightReporter: IframeHeightReporterService,
    private embeddedParentViewport: EmbeddedParentViewportService
  ) {
    this.formService.setFormDetails();
    console.log('Form V1.0.8');
  }
  title = 'Form'; 
  onGoToPage2(): boolean {
    return false;
  }

  ngOnInit(): void {
    this.iframeHeightReporter.start();
    this.embeddedParentViewport.start();
    this.signalRService.userCount$.subscribe();
  }

  ngOnDestroy(): void {
    this.iframeHeightReporter.stop();
    this.embeddedParentViewport.stop();
  }
}
